import React from 'react';
import { Instagram, Facebook, Mail, MapPin } from 'lucide-react';
import { assets } from '../lib/assets';

export default function Footer() {
  return (
    <footer className="bg-brand-ink text-brand-bg/80 pt-20 pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-12 mb-14">
          <div className="md:col-span-5">
            <div className="flex items-baseline gap-3 mb-3">
              <span className="font-serif text-4xl text-brand-bg tracking-tight">Pallavit</span>
              <span className="font-serif italic text-brand-gold text-lg">🌿</span>
            </div>
            <p className="font-serif italic text-brand-gold text-lg mb-5">Gift a Tree. Grow a Legacy.</p>
            <p className="text-brand-bg/70 max-w-md leading-relaxed text-[15px]">
              A family orchard turning meaningful gifts into living memories. Each tree, each name, each season — tended by hand.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-brand-gold text-xs tracking-[0.25em] uppercase mb-5">Explore</div>
            <ul className="space-y-3 text-[15px]">
              <li><a href="#about" data-testid="footer-link-about" className="hover:text-brand-gold transition-colors">About</a></li>
              <li><a href="#journey" data-testid="footer-link-journey" className="hover:text-brand-gold transition-colors">The Journey</a></li>
              <li><a href="#pricing" data-testid="footer-link-pricing" className="hover:text-brand-gold transition-colors">Plans</a></li>
              <li><a href="#story" data-testid="footer-link-story" className="hover:text-brand-gold transition-colors">Story</a></li>
              <li><a href="#trust" data-testid="footer-link-trust" className="hover:text-brand-gold transition-colors">Why Pallavit</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-brand-gold text-xs tracking-[0.25em] uppercase mb-5">Find us</div>
            <ul className="space-y-4 text-[15px]">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 text-brand-gold" />
                <span>Pallavit Orchard, Kalwan Taluka,<br />near Nashik, Maharashtra</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-1 text-brand-gold" />
                <a href="mailto:hello@pallavit.in" className="hover:text-brand-gold transition-colors">hello@pallavit.in</a>
              </li>
            </ul>
            <div className="flex gap-3 mt-6">
              <a href="#" aria-label="Instagram" data-testid="footer-social-instagram" className="w-10 h-10 rounded-full border border-brand-bg/20 flex items-center justify-center hover:bg-brand-gold hover:text-brand-ink hover:border-brand-gold transition-all">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" aria-label="Facebook" data-testid="footer-social-facebook" className="w-10 h-10 rounded-full border border-brand-bg/20 flex items-center justify-center hover:bg-brand-gold hover:text-brand-ink hover:border-brand-gold transition-all">
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-brand-bg/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-brand-bg/50">
          <div>© {new Date().getFullYear()} Pallavit. Planted with care.</div>
          <div className="font-serif italic text-brand-gold/80">"Trees are poems the earth writes upon the sky."</div>
        </div>
      </div>
    </footer>
  );
}
